var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2282_5144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16406 3.33417H3.33073C2.8887 3.33417 2.46478 3.50977 2.15222 3.82233C1.83966 4.13489 1.66406 4.55881 1.66406 5.00084V16.6675C1.66406 17.1095 1.83966 17.5335 2.15222 17.846C2.46478 18.1586 2.8887 18.3342 3.33073 18.3342H14.9974C15.4394 18.3342 15.8633 18.1586 16.1759 17.846C16.4885 17.5335 16.6641 17.1095 16.6641 16.6675V10.8342M15.4141 2.08417C15.7456 1.75265 16.1952 1.56641 16.6641 1.56641C17.1329 1.56641 17.5825 1.75265 17.9141 2.08417C18.2456 2.41569 18.4318 2.86533 18.4318 3.33417C18.4318 3.80301 18.2456 4.25265 17.9141 4.58417L9.9974 12.5008L6.66406 13.3342L7.4974 10.0008L15.4141 2.08417Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2282_5144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit2.65cf6c6fe7b6a99e54351948f9343429.svg";
export { ForwardRef as ReactComponent };